/** Two letters for a circle avatar: first and last word of a name, or the first two letters. */
export function initials(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  const first = words[0] as string;
  if (words.length === 1) return first.slice(0, 2).toUpperCase();
  return (first.charAt(0) + (words[words.length - 1] as string).charAt(0)).toUpperCase();
}
